



















































































































import { Component, Vue } from "vue-property-decorator";
import { required, email } from "vuelidate/lib/validators";
import { AxiosError } from "axios";
import { Action, namespace } from "vuex-class";
import { LoginPayload } from "../types";
import { errorParser } from "@/axios/utils/errorParser";

import {
  RoundedCrossSvg,
  RoundedPillSvg,
  RoundedRectangleSvg,
} from "@/modules/auth/components";

const Settings = namespace("settings");

@Component({
  components: {
    "rounded-cross-svg": RoundedCrossSvg,
    "rounded-pill-svg": RoundedPillSvg,
    "rounded-rectangle-svg": RoundedRectangleSvg,
  },
})
export default class Login extends Vue {
  @Action("auth/login") login!: (payload: LoginPayload) => Promise<{}>;
  @Settings.Getter("version") version;

  loading = false;
  error = "";
  loginForm = {
    email: "",
    password: "",
  };

  submitForm() {
    this.loading = true;
    this.login({
      email: this.loginForm.email,
      password: this.loginForm.password,
    })
      .then(() => {
        this.$router.replace({ name: "dashboard" });
        this.loading = false;
      })
      .catch((err: AxiosError) => {
        this.error = errorParser(err);
        this.loading = false;
      });
  }

  validations() {
    return {
      loginForm: {
        email: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    };
  }
}
